import EmailInteractionEvent from "../../../email/controller/EmailInteractionEvent";
import EmailBoxType from "../../../email/model/EmailBoxType";
import SmartphoneNavigateEvent from "../../model/SmartphoneNavigateEvent";
import SmartphoneSkinKeyRegistry from "../../model/SmartphoneSkinKeyRegistry";
import AbstractSmartphoneMediator from "../AbstractSmartphoneMediator";

export default class SmartphoneEmailConversationListScreenMediator extends AbstractSmartphoneMediator {
    constructor(target, dispatcher, emailModel, languagePack, mediatorManager, soundManager) {
        super(target, dispatcher);

        this._emailModel = emailModel;
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
        this._soundManager = soundManager;

        this._boxType = this.getCustomData().boxType;
    }

    initialize() {
        super.initialize();

        this._target.conversationList.customData = {
            skinKeyRegistry: SmartphoneSkinKeyRegistry,
            boxType: this._boxType,
            smallNpcImages: true
        };
        this._emailConversationListMediator = this._mediatorManager.createMediator(this._target.conversationList, SmartphoneSkinKeyRegistry.EMAIL_CONVERSATION_LIST_SKIN);

        switch (this._boxType) {
            case EmailBoxType.INBOX:
                this._target.applicationTitleTextField.text = this._languagePack.getText("email.boxSelection.inboxLabel");
                break;
            case EmailBoxType.DRAFTS:
                this._target.applicationTitleTextField.text = this._languagePack.getText("email.boxSelection.draftMailBoxLabel");
                break;
            case EmailBoxType.OUTBOX:
                this._target.applicationTitleTextField.text = this._languagePack.getText("email.boxSelection.sentMailBoxLabel");
                break;
        }

        this._closeButton = this.createInterfaceButton(this._target.closeButton, this._handleCloseButtonClick.bind(this));
        this._backButton = this.createInterfaceButton(this._target.backButton, this._handleBackButtonClick.bind(this));

        this._target.addEventListener('click', () => {});

        this.registerEventListener(EmailInteractionEvent.OPEN_CONVERSATION, this._handleOpenConversationRequest.bind(this));
    }

    destroy() {
        super.destroy();
        
        this._emailConversationListMediator.destroy();
    }

    _handleCloseButtonClick(mouseEvt) {
        const navEvt = new SmartphoneNavigateEvent(SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST);
        this.dispatch(navEvt.type, { data: navEvt });

        this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_MAIN_SCREEN_SKIN);
    }

    _handleBackButtonClick(mouseEvt) {
        this.closeScreen(this._target);
    }

    _handleOpenConversationRequest(evt) {
        this.openScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_EMAIL_SCREEN_SKIN, null, { conversation: evt.params.conversation });
    }
}